import { useTranslation } from 'react-i18next'

import { Loader2Icon } from 'lucide-react'

import { cn } from '@/lib/utils'

type Size = 'sm' | 'md' | 'lg'

export type LoadingSpinnerProps = {
  size?: Size
  className?: string
  resourceName?: string
}

const sizeMap = {
  sm: '4',
  md: '8',
  lg: '12',
} as const satisfies Record<Size, string>

export const LoadingSpinner = ({
  className,
  size = 'md',
  resourceName,
}: LoadingSpinnerProps) => {
  const { t } = useTranslation()
  const ariaLabel = resourceName
    ? t('common.loadingResource', { resource: resourceName })
    : t('common.loading')

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={ariaLabel}
      className="flex h-full items-center justify-center"
    >
      <Loader2Icon
        className={cn(
          'text-gray-300 animate-spin',
          `size-${sizeMap[size]}`,
          className,
        )}
      />
    </div>
  )
}
